module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表",
      "size": "small",
      "disabled": !_vm.filters.IsAdmin
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.WID),
      callback: function($$v) {
        _vm.$set(_vm.filters, "WID", $$v)
      },
      expression: "filters.WID"
    }
  }, _vm._l((_vm.warehouses), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "货主",
      "size": "small"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.OwnerID),
      callback: function($$v) {
        _vm.$set(_vm.filters, "OwnerID", $$v)
      },
      expression: "filters.OwnerID"
    }
  }, _vm._l((_vm.ownerList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "库存编码/包裹编码",
      "size": "small"
    },
    model: {
      value: (_vm.filters.KeyWord),
      callback: function($$v) {
        _vm.$set(_vm.filters, "KeyWord", $$v)
      },
      expression: "filters.KeyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearchSpu,
      "placeholder": "SPU / Name / SkuID",
      "size": "small"
    },
    on: {
      "select": _vm.handleSelectSpu
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name",
      "size": "small"
    },
    on: {
      "select": _vm.handleSelectSearch
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.downloadFile
    }
  }, [_vm._v("下载库存编码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.PrintPDF
    }
  }, [_vm._v("打印库存编码")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "id": "pdfDom",
      "data": _vm.WQCList,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "位置",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.GeoCode.Code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存编码/包裹编码/入库单号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.OrderID) + "/" + _vm._s(scope.row.Package.FreightNo) + "/"), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.LinkToStockIn(scope.row.StockIn.StockInOrder)
            }
          }
        }, [_vm._v(_vm._s(scope.row.StockIn.StockInOrder))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含产品",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.Package.Product), function(p) {
          return _c('p', {
            key: p.DataID
          }, [_vm._v("[" + _vm._s(p.Product.Status) + "] [" + _vm._s(p.Product.FullName) + "] " + _vm._s(p.Product.FullSKU) + " * " + _vm._s(p.Product.Quantity))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包裹规格",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "package-info",
          on: {
            "click": function($event) {
              _vm.editModel(true, scope)
            }
          }
        }, [_vm._v(_vm._s(scope.row.Package.Weight) + " g"), _c('br'), _vm._v(_vm._s(scope.row.Package.Length) + "*" + _vm._s(scope.row.Package.Width) + "*" + _vm._s(scope.row.Package.Height) + "cm "), (!scope.row.ExecuteQC) ? _c('span', {
          staticClass: "package-info-msg"
        }, [_vm._v("包裹规格需完善")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "属性",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.StockIn.Level !== '普通'),
            expression: "scope.row.StockIn.Level!=='普通'"
          }],
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.StockIn.Level)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.StockIn.NewProduct !== '普通'),
            expression: "scope.row.StockIn.NewProduct!=='普通'"
          }],
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.StockIn.NewProduct)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "待质检数量",
      "prop": "Quantity",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "执行数量",
      "prop": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "",
            "disabled": !scope.row.ExecuteQC
          },
          model: {
            value: (scope.row.executeQuantuty),
            callback: function($$v) {
              _vm.$set(scope.row, "executeQuantuty", $$v)
            },
            expression: "scope.row.executeQuantuty"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "UpdateDate",
      "label": "时间",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("cutDate")(scope.row.UpdateDate)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n    转入库区 \n    "), _c('el-select', {
    attrs: {
      "placeholder": "库区列表",
      "size": "small"
    },
    model: {
      value: (_vm.WARID),
      callback: function($$v) {
        _vm.WARID = $$v
      },
      expression: "WARID"
    }
  }, _vm._l((_vm.WAList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.ACode + ' - ' + item.Types
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": this.sels.length === 0 || _vm.listLoading,
      "size": "small"
    },
    on: {
      "click": _vm.execute
    }
  }, [_vm._v("执行")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-sizes": [20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editModelShow,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editModelShow = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "重量"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "id": "editformWeight"
    },
    model: {
      value: (_vm.editForm.Weight),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Weight", $$v)
      },
      expression: "editForm.Weight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("单位g")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('label', [_vm._v("规格")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.Length),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Length", $$v)
      },
      expression: "editForm.Length"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.Width),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Width", $$v)
      },
      expression: "editForm.Width"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.Height),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Height", $$v)
      },
      expression: "editForm.Height"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("长宽高，单位cm")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editModel(false)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b115b7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/qualityControl/WQCList.vue
// module id = 844
// module chunks = 1